import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import type {
    GetLimits as GetLimitsQuery,
    GetLimitsVariables as GetLimitsQueryVariables,
    LimitedType,
} from 'nutshell-graphql-types';

import GET_LIMITS from './graphql/queries/get-limits.graphql';

export const useGetLimitsByType = (type?: LimitedType | null, shouldSkip?: boolean) => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetLimitsQuery, GetLimitsQueryVariables>(GET_LIMITS, {
        // @ts-expect-error
        variables: {type},
        fetchPolicy: 'cache-and-network',
        skip: shouldSkip || !type,
    });

    const limits = data ? data.limits : null;

    return {
        isLoading,
        limits,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
